import { __assign, __rest } from "tslib";
import React, { Fragment } from 'react';
import { Loader } from '@marvelapp/ui';
import { SpecsBorderItem } from '@marvelapp/ui-internal';
import * as handoffState from '../../constants/handoffState';
import { PENDING, SUCCESS } from '../../constants/requestStatus';
import PanelColours from '../../containers/handoff/PanelColours';
import ColumnSettings from '../../containers/handoff/layout/ColumnSettings';
import RowSettings from '../../containers/handoff/layout/RowSettings';
import PanelArtboard from './PanelArtboard';
import PanelFonts from './PanelFonts';
import SidebarState, { ContactButton, FindOutMoreButtton, SignInButton, } from './sidebar/SidebarState';
export default function HandoffDefault(_a) {
    var artboard = _a.artboard, fonts = _a.fonts, state = _a.handoffState, onClose = _a.onClose, requestStatus = _a.requestStatus;
    var content;
    if (state !== handoffState.AVAILABLE) {
        var _b = getSidebarProps({
            state: state,
        }), children = _b.children, sidebarProps = __rest(_b, ["children"]);
        content = (React.createElement(SidebarState, __assign({ onClose: onClose }, sidebarProps), children));
    }
    else if (requestStatus === PENDING) {
        content = (React.createElement(SpecsBorderItem, { alignItems: "center", ignoreLastChild: true, justifyContent: "center", padding: 40 },
            React.createElement(Loader, { size: 32 })));
    }
    else if (requestStatus === SUCCESS) {
        content = (React.createElement(Fragment, null,
            React.createElement(PanelArtboard, __assign({ key: "artboard" }, artboard)),
            React.createElement(PanelColours, null),
            fonts.length > 0 && React.createElement(PanelFonts, { fonts: fonts, key: "fonts" }),
            React.createElement(ColumnSettings, null),
            React.createElement(RowSettings, null)));
    }
    return React.createElement(Fragment, null, content);
}
function getSidebarProps(_a) {
    var state = _a.state;
    switch (state) {
        case handoffState.UNAVAILABLE:
            return {
                heading: 'Handoff access unavailable',
                message: 'Handoff is only available to users on the company account. Request access from the owner to get started.',
                image: 'handoff',
            };
        case handoffState.UNAUTHORIZED:
            return {
                heading: 'Sign in to view Handoff',
                message: 'Access code, specs and assets when you sign in to your company account',
                children: React.createElement(SignInButton, null),
                image: 'handoff',
            };
        case handoffState.NO_HANDOFF_DATA:
            return {
                heading: 'Code, specs and assets have not been generated',
                message: 'Find out how to use Handoff and save hours for your developers',
                image: 'handoff',
                children: React.createElement(FindOutMoreButtton, null),
            };
        case handoffState.REQUEST_ERROR:
            return {
                heading: 'Oops, something went wrong',
                message: 'Please try uploading your screen again or contact support',
                image: 'error',
                children: React.createElement(ContactButton, null),
            };
        default:
            return {};
    }
}
